<template>
  <div>
    <div class="headers">
      <div class="containerBox">
        <div
          class="header flex align-items"
          style="justify-content: space-between"
        >
          <div
            class="left flex align-items"
            style="cursor: pointer"
            @click="toHome"
          >
            <img class="img" src="../assets/img/sssssssss/logoNew.png" alt="" />
          </div>
          <div class="right flex align-items">
            <nav class="nav">
              <template v-for="(item, index) in navList">
                <div
                  v-if="!item.hidden"
                  @mouseenter="handleMouseEnter(index)"
                  class="nav-itemBox"
                  @mouseleave="handleMouseLeave(index)"
                  :key="item.id"
                >
                  <router-link
                    v-if="item.id !== 8"
                    :to="{
                      path:
                        index !== 1 && item.path !== '/information'
                          ? item.path
                          : '',
                    }"
                    :target="item.target"
                    class="nav-item"
                    :class="{
                      active:
                        index != 0 &&
                        ((item.copy && $route.path.indexOf(item.copy) > -1) ||
                          $route.path.indexOf(item.path) > -1),
                    }"
                  >
                    <div
                      v-if="item.id === 9"
                      @click.prevent.stop="handleLCMTitleClick"
                    >
                      {{ item.name }}
                    </div>
                    <div v-else>{{ item.name }}</div>
                    <div
                      class="childNavMeun"
                      v-show="
                        item.show && item.children && item.children.length > 0
                      "
                    >
                      <div
                        class="childNavMeunList"
                        v-for="items in item.children"
                        :key="items.id"
                      >
                        <router-link
                          v-if="index == 2 || index == 3"
                          :style="
                            isChildNavActive(item, items, index)
                              ? 'color: #00d8c3;'
                              : ''
                          "
                          class="childNavMeunLink"
                          :to="{ path: items.path }"
                          >{{ items.name }}</router-link
                        >
                        <a
                          v-else-if="index === 9"
                          class="childNavMeunLink"
                          href="javascript:;"
                          @click.prevent="handleLCMClick(items)"
                          >{{ items.name }}</a
                        >
                        <router-link
                          v-else
                          :style="
                            isChildNavActive(item, items, index)
                              ? 'color: #00d8c3;'
                              : ''
                          "
                          class="childNavMeunLink"
                          :to="{ path: items.path }"
                          >{{ items.name }}</router-link
                        >
                      </div>
                    </div>
                  </router-link>

                  <a
                    v-else
                    @click="handleLDesignClick"
                    class="nav-item"
                    style="cursor: pointer"
                  >
                    <div>{{ item.name }}</div>
                  </a>
                </div>
              </template>
            </nav>
            <login-menu ref="loginMenu" :scrollState="true" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loginMenu from "@/components/login-menu";

import { videoClassifyList } from "@/api/lx";
import { getLDesignPlatformUrl, getLCMPlatformUrl } from "@/api/apis";

let cachedVideoClassify = null;

export default {
  components: {
    loginMenu,
  },
  data() {
    return {
      path: this.$route.fullPath,
      navList: [
        { id: 1, name: "首页", path: "/" },
        {
          id: 2,
          name: "资料获取",
          path: "/information",
          show: false,
          children: [
            { id: 9, name: "产品手册", path: "/information/productManual" },
            // { id: 10, name: "解决方案", path: "/information/solution" },
            // { id: 11, name: "市场业绩", path: "/information/achievement" },
            { id: 12, name: "软件及工具", path: "/information/tool" },
          ],
        },
        {
          id: 3,
          name: "培训学院",
          path: "/school/index",
          show: false,
          children: [],
        },
        {
          id: 13,
          name: "新闻中心",
          path: "/news/index?id=1",
          show: false,
          children: [
            { id: 1, name: "新闻资讯", path: "/news/index?id=1" },
            { id: 2, name: "产品公告", path: "/news/index?id=2" },
          ],
        },
        { id: 4, name: "服务权益", path: "/service/index" },
        { id: 5, name: "社区联盟", path: "/community/index" },
        { id: 6, name: "常见问题", path: "/forum/index" },
        { id: 7, name: "积分商城", path: "/shop/index", hidden: true },
        {
          id: 8,
          name: "L-Design平台",
          path: "http://101.245.69.18:81/index.html#/login?redirect=drawingDownload",
        },
        {
          id: 9,
          name: "LCM平台",
          show: false,
          children: [
            { id: 0, name: "项目查重", path: "/project/check" },
            { id: 1, name: "项目新建", path: "/project/create" },
            { id: 2, name: "项目管理", path: "/project/manage" },
          ],
        },
        {
          id: 10,
          name: "LWS良仓",
          path: "/lws/index",
        },
      ],
    };
  },
  created() {
    this.getVideoClassifyList();
  },
  watch: {
    "$route.fullPath"(fullPath) {
      this.path = fullPath;
    },
  },
  methods: {
    /**
     * 判断二级子菜单项是否为当前激活高亮状态
     * 解决某些详情页 query 带有 id=1 或 id=2 时盲目使用 indexOf(items.id) 导致误将新闻中心子菜单高亮的问题
     * @param {Object} item - 一级菜单对象
     * @param {Object} items - 二级子菜单对象
     * @param {number} index - 菜单项索引
     * @returns {boolean} 是否呈现高亮
     */
    isChildNavActive(item, items, index) {
      if (!this.path) return false;
      // 培训学院 (index === 2)
      if (index === 2) {
        return (
          this.$route.path.indexOf("/school") !== -1 &&
          (this.$route.query.id == items.id || this.path.indexOf(items.path) !== -1)
        );
      }
      // 新闻中心 (index === 3)
      if (index === 3) {
        return (
          this.$route.path.indexOf("/news") !== -1 &&
          (this.$route.query.id == items.id || this.path.indexOf(items.path) !== -1)
        );
      }
      // 资料获取 (index === 1) 及其他子导航
      if (items.path) {
        return this.path.indexOf(items.path) !== -1;
      }
      return false;
    },
    toHome() {
      this.$router.push("/");
    },
    getVideoClassifyList() {
      // if (cachedVideoClassify) {
      //   this.navList[2].children = cachedVideoClassify;
      //   return;
      // }
      // videoClassifyList({}).then((res) => {
      //   const children = res.data.map((ele) => ({
      //     ...ele,
      //     path: "/school/index?id=" + ele.id,
      //   }));
      //   cachedVideoClassify = children;
      //   this.navList[2].children = children;
      // });
    },
    refresh() {
      this.$refs.loginMenu.refresh();
    },
    // 鼠标移入方法
    handleMouseEnter(index) {
      const dropdownIndexes = [1, 2, 3, 9];
      if (dropdownIndexes.includes(index)) {
        dropdownIndexes.forEach((i) => {
          this.navList[i].show = false;
        });
        this.navList[index].show = true;
      }
    },
    handleMouseLeave() {
      [1, 2, 3, 9].forEach((i) => {
        this.navList[i].show = false;
      });
    },
    // 处理L-Design平台点击
    handleLDesignClick() {
      getLDesignPlatformUrl()
        .then((res) => {
          if (res.code === 200 && res.data) {
            window.open(res.data.url, "_blank");
          } else {
            this.$message.error("获取L-Design平台地址失败");
          }
        })
        .catch((error) => {
          console.error("获取L-Design平台地址失败:", error);
          this.$message.error("获取L-Design平台地址失败");
        });
    },
    // 处理LCM平台点击
    handleLCMClick(items) {
      const type = items.id;
      getLCMPlatformUrl()
        .then((res) => {
          if (res.code === 200 && res.data) {
            window.open(res.data[items.id].url, "_blank");
          } else {
            this.$message.error("获取LCM平台地址失败");
          }
        })
        .catch((error) => {
          console.error("获取LCM平台地址失败:", error);
          this.$message.error("获取LCM平台地址失败");
        });
    },
    // 处理LCM平台大标题点击，跳转到第四个链接（下标是3）
    handleLCMTitleClick() {
      getLCMPlatformUrl()
        .then((res) => {
          if (res.code === 200 && res.data) {
            if (res.data[3] && res.data[3].url) {
              window.open(res.data[3].url, "_blank");
            } else {
              this.$message.error("获取LCM平台主地址失败");
            }
          } else {
            this.$message.error("获取LCM平台地址失败");
          }
        })
        .catch((error) => {
          console.error("获取LCM平台地址失败:", error);
          this.$message.error("获取LCM平台地址失败");
        });
    },
  },
};
</script>

<style scoped lang="less">
.containerBox {
  width: 1800px;
  margin: 0 auto;
}
.headers {
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  .img {
    height: 36px;
    //width: 130px;
  }
}
.nav {
  display: flex;
  align-items: center;
  margin-right: 50px;
  .nav-itemBox {
    padding: 0 25px;
    .nav-item {
      position: relative;
      text-align: center;
      color: #00161a;
      display: block;
      cursor: pointer;
      text-decoration: none;
      position: relative;
      font-size: 18px;
      line-height: 74px;
      h3 {
        font-size: 18px;
      }
    }
    .active div {
      color: #00d8c3 !important;
    }
  }
}
.childNavMeun {
  position: absolute;
  top: 74px;
  left: -57px;
  background-color: #fff;
  width: 175px;
  padding: 5px 0;
  z-index: 999;
  .childNavMeunList {
    line-height: 40px !important;
    .childNavMeunLink {
      cursor: pointer;
      font-size: 16px;
      color: #00161a;
      text-decoration: none;
    }
  }
}

/deep/.header-custom-btn {
  color: #2e3033;
  border-color: transparent;
  background-color: transparent;

  a {
    color: initial;
    text-decoration: none;
  }
}

/deep/.user-info {
  .el-dropdown-link {
    color: #2e3033;
    cursor: pointer;
  }
}
</style>
